import Dexie, { type Table } from 'dexie';
import type {
  Building, Floor, Room, Person, Department,
  Asset, DeviceAssignment,
  DataJack, PatchPanel, PatchPanelPort, SwitchPort, NetworkDevice, Vlan, NetworkPath,
  WorkOrder, MaintenanceTask, ChangeRequest,
  Incident,
  Vendor, Service, ObservedDevice, DatasetMetadata
} from '../domain';

export class CrocOpsDatabase extends Dexie {
  buildings!: Table<Building, string>;
  floors!: Table<Floor, string>;
  rooms!: Table<Room, string>;
  persons!: Table<Person, string>;
  departments!: Table<Department, string>;

  assets!: Table<Asset, string>;
  observedDevices!: Table<ObservedDevice, string>;
  datasetMetadata!: Table<DatasetMetadata, string>;
  deviceAssignments!: Table<DeviceAssignment, string>;

  dataJacks!: Table<DataJack, string>;
  patchPanels!: Table<PatchPanel, string>;
  patchPanelPorts!: Table<PatchPanelPort, string>;
  networkDevices!: Table<NetworkDevice, string>;
  switchPorts!: Table<SwitchPort, string>;
  vlans!: Table<Vlan, string>;
  networkPaths!: Table<NetworkPath, string>;

  workOrders!: Table<WorkOrder, string>;
  maintenanceTasks!: Table<MaintenanceTask, string>;
  changeRequests!: Table<ChangeRequest, string>;

  incidents!: Table<Incident, string>;

  vendors!: Table<Vendor, string>;
  services!: Table<Service, string>;

  constructor() {
    super('CrocOpsDB');
    this.version(2).stores({
      buildings: 'id, name',
      rooms: 'id, floorId, name',
      persons: 'id, departmentId, email',
      departments: 'id, name',
      assets: 'id, assetTypeId, state, locationId',
      deviceAssignments: 'id, assetId, personId',
      dataJacks: 'id, roomId, status',
      patchPanels: 'id, roomId',
      patchPanelPorts: 'id, panelId',
      networkDevices: 'id, roomId',
      switchPorts: 'id, deviceId, vlanId',
      vlans: 'id, vid',
      networkPaths: 'id, sourceId, targetId',
      workOrders: 'id, state',
      maintenanceTasks: 'id, maintenancePlanId',
      changeRequests: 'id, status',
      incidents: 'id, state, severity',
      vendors: 'id, status',
      services: 'id, vendorId, health'
    });
    this.version(3).stores({
      buildings: 'id, name',
      floors: 'id, buildingId, level',
      rooms: 'id, floorId, name',
      persons: 'id, departmentId, email',
      departments: 'id, name',
      assets: 'id, assetTypeId, state, health, locationId, category, ownership',
      observedDevices: 'id, pseudonymousId, deviceClass, buildingId, connectionState',
      datasetMetadata: 'id, profileId, version',
      deviceAssignments: 'id, assetId, personId',
      dataJacks: 'id, roomId, status',
      patchPanels: 'id, roomId',
      patchPanelPorts: 'id, panelId',
      networkDevices: 'id, roomId',
      switchPorts: 'id, deviceId, vlanId',
      vlans: 'id, vid',
      networkPaths: 'id, sourceId, targetId',
      workOrders: 'id, state',
      maintenanceTasks: 'id, maintenancePlanId',
      changeRequests: 'id, status',
      incidents: 'id, state, severity',
      vendors: 'id, status',
      services: 'id, vendorId, health'
    });
  }
}

export const db = new CrocOpsDatabase();
